import { ErrorComponent, type ErrorComponentProps } from '@tanstack/react-router';
import { useEffect, useSyncExternalStore } from 'react';
import { Button } from '@/components/ui/button';
import { isChunkLoadError, recoverFromChunkError, staleBuild } from '@/lib/stale-build';

function NewVersionMessage() {
  return (
    <div
      role="alert"
      className="flex items-center gap-3 rounded-lg border bg-card px-4 py-3 text-sm shadow-lg"
    >
      <span>A new version of Yedo Books is available.</span>
      <Button size="sm" onClick={() => window.location.reload()}>
        Reload
      </Button>
    </div>
  );
}

/** Shown after a deploy when reloading once did not recover (lib/stale-build.ts). */
export function NewVersionBanner() {
  const show = useSyncExternalStore(staleBuild.subscribe, staleBuild.get);
  if (!show) return null;
  return (
    <div className="fixed inset-x-0 top-3 z-[100] flex justify-center px-4">
      <NewVersionMessage />
    </div>
  );
}

/** Router error page: a lazy route that failed to load after a deploy reloads once. */
export function RouteError(props: ErrorComponentProps) {
  const chunk = isChunkLoadError(props.error);
  useEffect(() => {
    if (chunk) recoverFromChunkError();
  }, [chunk]);
  if (!chunk) return <ErrorComponent {...props} />;
  return (
    <div className="flex justify-center p-8">
      <NewVersionMessage />
    </div>
  );
}
